export const convertDate = (timestamp) => {
  if (!timestamp) return "";

  if (typeof timestamp === "string") {
    return timestamp.slice(0, 10);
  }

  let timestampInMillis = timestamp;
  if (String(timestamp).length < 13) {
    timestampInMillis = timestamp * 1000;
  }
  const dateObject = new Date(timestampInMillis);
  const isoString = dateObject.toISOString();

  return isoString.slice(0, 10);
};
export const convertHours = (timestamp) => {
  if (!timestamp) return "";

  let timestampInMillis = timestamp;
  if (typeof timestamp !== "string" && String(timestamp).length < 13) {
    timestampInMillis = timestamp * 1000;
  }

  const dateObject = new Date(timestampInMillis);

  const hours = String(dateObject.getHours()).padStart(2, "0");
  const minutes = String(dateObject.getMinutes()).padStart(2, "0");
  return `${hours}:${minutes}`;
};
